"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FocusTrap = FocusTrap;

var _shared = require("@clayui/shared");

var _ariaHidden = require("aria-hidden");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getFocusableElements = function getFocusableElements(childrenRef) {
  if (!childrenRef.current) {
    return null;
  }

  return _toConsumableArray(childrenRef.current.querySelectorAll(_shared.FOCUSABLE_ELEMENTS.join(','))).filter(function (element) {
    return !element.getAttribute('aria-hidden');
  });
};

function FocusTrap(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children,
      focusElementRef = _ref.focusElementRef;
  var childrenRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (active) {
      if (focusElementRef !== null && focusElementRef !== void 0 && focusElementRef.current) {
        focusElementRef.current.focus();
        return;
      }

      var focusableElements = getFocusableElements(childrenRef);

      if (focusableElements !== null && focusableElements !== void 0 && focusableElements.length) {
        focusableElements[0].focus();
      }
    }
  }, [active]);
  (0, _react.useEffect)(function () {
    if (childrenRef.current && active) {
      // Inert is a new native feature to better handle DOM arias that are not
      // assertive to a SR or that should ignore any user interaction.
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert
      if ((0, _ariaHidden.supportsInert)()) {
        return (0, _ariaHidden.suppressOthers)(childrenRef.current);
      } else {
        return (0, _ariaHidden.hideOthers)(childrenRef.current);
      }
    }
  }, [active]);
  return /*#__PURE__*/_react.default.createElement(_shared.FocusScope, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: childrenRef,
    style: {
      display: 'contents'
    }
  }, active ? /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true",
    "data-focus-scope-start": "true",
    tabIndex: 0
  }) : null, children, active ? /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true",
    "data-focus-scope-end": "true",
    tabIndex: 0
  }) : null));
}